module.exports = () => parseInt(Math.random() * 1e12, 10).toString(36);
